import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { format } from "date-fns";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useStripe, CardCvcElement, useElements } from "@stripe/react-stripe-js";
import { Country, State, City } from "country-state-city";
import { CardElement } from "@stripe/react-stripe-js";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CompleteRegistration from "../../components/CompleteRegistration";
import StripeWrapper from "../../components/StripeWrapper"
import AddPaymentMethodForPurchase from "../../components/AddPaymentMethodForPurchase"
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { AuthContext } from "../../helpers/AuthContext";
import LaunchInstance from "../../components/LaunchInstance"

function InstancePaymentFailed() {
  return (
  <StripeWrapper>
    <LaunchInstance/>
  </StripeWrapper>
  )
}

export default InstancePaymentFailed;
